import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { CheckCircle as CheckCircleIcon, Error as ErrorIcon } from '@mui/icons-material';
import { colors, fonts, spacing, borderRadius } from '../../../constants';
import {
  successListStyles,
  errorListStyles,
  ICON_SIZES,
} from '../../../constants/importDialog';

/**
 * ImportResultsDisplay Component
 * Displays import results with success and error lists
 */
const ImportResultsDisplay = ({ importResults }) => {
  if (!importResults) return null;

  const getAlertSeverity = () => {
    if (importResults.success === false) {
      return 'error';
    }
    return importResults.data?.errors?.length === 0 ? 'success' : 'warning';
  };

  return (
    <Box>
      <Alert severity={getAlertSeverity()} sx={{ mb: spacing.sm }}>
        {importResults.message || 'Import completed'}
      </Alert>

      {importResults.data?.success && importResults.data.success.length > 0 && (
        <Box sx={{ mb: spacing.sm }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: fonts.weightSemiBold,
              color: colors.success,
              fontSize: fonts.fontSizeSm,
              mb: spacing.xs,
              display: 'flex',
              alignItems: 'center',
              gap: spacing.xs,
            }}
          >
            <CheckCircleIcon sx={{ fontSize: ICON_SIZES.STATUS_ICON }} />
            {importResults.data.success.length} user(s) imported successfully
          </Typography>
          <Box sx={successListStyles}>
            {importResults.data.success.map((user, index) => (
              <Typography
                key={index}
                variant="caption"
                sx={{
                  display: 'block',
                  color: colors.textSecondary,
                  fontSize: fonts.fontSizeXs,
                  mb: spacing.xs,
                }}
              >
                ✓ Row {user.row}: {user.name} ({user.email})
              </Typography>
            ))}
          </Box>
        </Box>
      )}

      {importResults.data?.errors && importResults.data.errors.length > 0 && (
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: fonts.weightSemiBold,
              color: colors.error,
              fontSize: fonts.fontSizeSm,
              mb: spacing.xs,
              display: 'flex',
              alignItems: 'center',
              gap: spacing.xs,
            }}
          >
            <ErrorIcon sx={{ fontSize: ICON_SIZES.STATUS_ICON }} />
            {importResults.data.errors.length} error(s) occurred
          </Typography>
          <Box sx={errorListStyles}>
            {importResults.data.errors.map((error, index) => (
              <Typography
                key={index}
                variant="caption"
                sx={{
                  display: 'block',
                  color: colors.error,
                  fontSize: fonts.fontSizeXs,
                  mb: spacing.xs,
                }}
              >
                ✗ Row {error.row} {error.email ? `(${error.email})` : ''}: {error.error}
              </Typography>
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ImportResultsDisplay;
